import { all } from 'redux-saga/effects'

import { watchRequests } from './network'

import analytics from './analytics'
import authSaga from './auth'
import claimTokens from './claimTokens'
import clubsSaga from './clubs'
import connectedUnions from './connectedUnions'
import ghostUsers from './ghostUsers'
import guidesSaga from './guides'
import organisations from './organisations'
import profileSaga from './profile'
import resetPasswordSaga from './resetPassword'
import signupSaga from './signup'
import shotsSaga from './shots'
import matchesSaga from './matches'

export default function * rootSaga () {
  yield all([
    analytics(),
    authSaga(),
    claimTokens(),
    clubsSaga(),
    connectedUnions(),
    ghostUsers(),
    guidesSaga(),
    organisations(),
    profileSaga(),
    resetPasswordSaga(),
    signupSaga(),
    shotsSaga(),
    watchRequests(),
    matchesSaga()
  ])
}
